import React, {ReactNode, useCallback, useEffect, useState} from 'react';
import Card from '@mui/material/Card';
import Collapse from '@mui/material/Collapse';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Box, ButtonBase} from '@mui/material';
import {trackPOCToolCategory} from '../../../Util/firebaseAnalytics';

type Props = {
  children: ReactNode;
  title: string;
  itemHeaderContainerStyle?: object;
  containerStyle?: object;
  fontStyle?: object;
  iconStyle?: object;
  isOpen: boolean;
  toolName?: string;
};

export default function CustomCollapsible(props: Props) {
  const {
    children,
    title,
    itemHeaderContainerStyle,
    containerStyle,
    fontStyle,
    iconStyle,
    toolName,
  } = props;

  const [isOpen, setOpen] = useState(props.isOpen);
  const Children = children;

  useEffect(() => {
    setOpen(props.isOpen);
  }, [props.isOpen]);

  const handlePress = useCallback(() => {
    setOpen(!isOpen);
    if (
      toolName === 'Smart Phrases' &&
      toolName !== undefined &&
      title !== undefined &&
      isOpen === false
    ) {
      trackPOCToolCategory(toolName, title);
    }
  }, [toolName, title, isOpen]);

  return (
    <Card sx={styles.cardStyle} style={{...containerStyle, marginBottom: 10}}>
      <ButtonBase onClick={handlePress} style={{width: '100%'}}>
        <CardHeader
          title={title}
          titleTypographyProps={fontStyle}
          style={{
            ...itemHeaderContainerStyle,
            paddingLeft: 20,
            width: '100%',
            textAlign: 'left',
          }}
          action={
            <Box style={iconStyle}>
              {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </Box>
          }></CardHeader>
      </ButtonBase>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <CardContent style={styles.cardContentStyle}>{Children}</CardContent>
      </Collapse>
    </Card>
  );
}

const styles = {
  cardStyle: {
    minWidth: 300,
    border: '1px solid #DDDDDD',
    borderRadius: 1,
    boxShadow: 'none',
  },
  cardContentStyle: {
    margin: 0,
    padding: 0,
    paddingBottom: 5,
    backgroundColor: '#FFFFFF',
    marginTop: 10,
  },
};
